<!-- FreeAccountModal.vue -->
<script setup>
import BaseModal from './BaseModal.vue';

const props = defineProps({
  show: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(['close']);

const close = () => {
  emit('close');
};
</script>

<template>
  <BaseModal :show="show" @close="close">
    <!-- Icon Slot -->
    <template #icon>
      <i class="bi bi-person-circle" style="color: #007bff;"></i>
    </template>

    <!-- Message Slot -->
    <template #message>
      <h2>Create a Free Account</h2>
      <p>Join us for free to unlock access to all bookmakers. No card details required!</p>
    </template>

    <!-- Actions Slot -->
    <template #actions>
      <a href="/sign-up/" class="button button-continue">Create Free Account</a>
      <button @click="close" class="button button-close" datatype="inverted">Continue</button>

    </template>
  </BaseModal>
</template>

<style scoped>
/* Additional Styles for FreeAccountModal */
.modal-icon i {
  font-size: 5rem;
}
</style>
